import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/ui/Button";
import Icon from "../../../components/AppIcon";

const RelatedRooms = ({ rooms = [], viewAllPath = "/sobe" }) => {
  const navigate = useNavigate();
  if (!rooms?.length) return null;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground">
          More Rooms You Might Like
        </h2>
        <Button
          variant="outline"
          iconName="ArrowRight"
          iconPosition="right"
          onClick={() => navigate(viewAllPath)}
        >
          View All
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {rooms.map((r, idx) => {
          const img = r?.image || r?.imageUrl || "";
          const title = r?.title || "Room";

          return (
            <div
              key={idx}
              className="bg-card rounded-xl shadow-subtle hover:shadow-medium transition-smooth overflow-hidden group cursor-pointer"
              onClick={() => navigate(r?.link || `/room/${r?.id}`)}
            >
              {/* Image */}
              <div className="relative w-full aspect-[16/9] overflow-hidden bg-muted">
                {img ? (
                  <img
                    src={img}
                    alt={title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-smooth"
                    onError={(e) => {
                      e.currentTarget.src =
                        "https://placehold.co/800x450?text=Photo+unavailable";
                    }}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-muted-foreground text-sm">
                    No image
                  </div>
                )}
                <div className="absolute top-4 left-4">
                  <span className="bg-primary text-primary-foreground px-3 py-1 rounded-full text-xs font-medium">
                    {r?.status || "Available"}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="font-heading text-xl font-semibold text-foreground group-hover:text-primary transition-smooth">
                    {title}
                  </h3>
                  {r?.price != null && (
                    <div className="text-right">
                      <p className="font-heading text-lg font-bold text-primary">
                        €{r.price}
                      </p>
                      <p className="text-xs text-muted-foreground">per night</p>
                    </div>
                  )}
                </div>

                <Button
                  variant="outline"
                  size="sm"
                  fullWidth
                  iconName="Eye"
                  iconPosition="left"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(r?.link || `/room/${r?.id}`);
                  }}
                >
                  View Details
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RelatedRooms;
